/*!
 * Copyright © 2019-2020. Verizon Connect Ireland Limited. All rights reserved.
 */

import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { AssetMarkerInfo, IMapContextMenuData, IMapContextMenuPermissions } from '../../../core/models';

@Component({
  selector: 'fm-asset-menu-container',
  templateUrl: './asset-menu-container.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AssetMenuContainerComponent {
  @Input()
  public menuData: IMapContextMenuData<AssetMarkerInfo>;

  @Input()
  public userPermissions: IMapContextMenuPermissions;

  @Input()
  public isPingMVPEnabled: boolean;

  @Input()
  public fleetAndDeviceListFeatureToggleEnabled: boolean;

  @Output()
  public closed: EventEmitter<void> = new EventEmitter();

  @Output()
  public findNearestClicked: EventEmitter<void> = new EventEmitter();

  @Output()
  public zoomToClicked: EventEmitter<void> = new EventEmitter();

  @Output()
  public streetViewClicked: EventEmitter<void> = new EventEmitter();

  @Output()
  public createGeofenceClicked: EventEmitter<void> = new EventEmitter();

  @Output()
  public getDirectionToClicked: EventEmitter<void> = new EventEmitter();

  @Output()
  public getDirectionFromClicked: EventEmitter<void> = new EventEmitter();

  @Output()
  public editAssetClicked: EventEmitter<void> = new EventEmitter();

  @Output()
  public copyCoordinatesClicked: EventEmitter<string> = new EventEmitter();

  @Output()
  public viewReplayClicked: EventEmitter<void> = new EventEmitter();

  @Output()
  public locationHistoryClicked: EventEmitter<void> = new EventEmitter();

  @Output()
  public troubleshootAssetClicked: EventEmitter<void> = new EventEmitter();

  public onMenuClosed(): void {
    this.closed.emit();
  }

  public onFindNearestClicked(): void {
    this.findNearestClicked.emit();
    this.closed.emit();
  }

  public onZoomToClicked(): void {
    this.zoomToClicked.emit();
    this.closed.emit();
  }

  public onStreetViewClicked(): void {
    if (this.menuData.streetViewAvailable) {
      this.streetViewClicked.emit();
      this.closed.emit();
    }
  }

  public onCreateGeofenceClicked(): void {
    this.createGeofenceClicked.emit();
    this.closed.emit();
  }

  public onGetDirectionToClicked(): void {
    this.getDirectionToClicked.emit();
    this.closed.emit();
  }

  public onGetDirectionFromClicked(): void {
    this.getDirectionFromClicked.emit();
    this.closed.emit();
  }

  public onEditAssetClicked(): void {
    this.editAssetClicked.emit();
    this.closed.emit();
  }

  public onCopyCoordinates(coordinatesToCopy: string): void {
    this.copyCoordinatesClicked.emit(coordinatesToCopy);
  }

  public onViewReplayClicked(): void {
    this.viewReplayClicked.emit();
    this.closed.emit();
  }

  public onLocationHistoryClicked(): void {
    this.locationHistoryClicked.emit();
    this.closed.emit();
  }

  public onTroubleshootAssetClicked(): void {
    this.troubleshootAssetClicked.emit();
    this.closed.emit();
  }
}
